const PERMISSION = {
  NOT_FOUND: 'Permission not found.',
  CREATED: 'Permission created successfully.',
  UPDATED: 'Permission updated successfully.',
  UPDATED_PERMISSIONS: 'Permissions updated successfully.',
  DELETED: 'Permission deleted successfully.',
  REPLACEMENT_PERMISSION_NOT_FOUND: 'Replacement permission not found.',
  REPLACEMENT_PERMISSION_ID_REQUIRED: 'Replacement permission id is required.',
  CANNOT_DEPRECATE_PERMISSION_IN_USE:
    'Cannot deprecate permission that is in use without a replacement.',
  DEPRECATED_SUCCESSFULLY: 'Permission deprecated successfully.',
  IN_USE: (count: number): string =>
    `Permission is currently in use by ${count} role${
      count === 1 ? '' : 's'
    }. Please transfer to another permission by providing replacement permission id before deleting.`,
  TRANSFER_TARGET_NOT_FOUND: 'The permission to transfer to does not exist.',
  TRANSFER_TARGET_INVALID:
    'The target permission for transfer must be active and not deprecated.',
  PERMISSION_ALREADY_EXISTS: 'Permission with this identifier already exists.',
  DELETED_BY_ADMINISTRATOR: 'Deleted by administrator.',
  INITIALIZED: 'Permissions successfully initialized.',
  IDENTIFIER_REQUIRED: 'Permission identifier is required.',
  ID_REQUIRED: 'Permission id is required.',
  TITLE_REQUIRED: 'Permission title is required.',
  TRANSFERRED_AND_DELETED: 'Permission transferred and deleted successfully.',
} as const;

export default PERMISSION;
